import React, { useEffect } from 'react'
// import Loader from '../components/Loader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { decryptAndRetrieveData } from './login/encript-decript'
import { CircularProgress } from '@mui/material'
import { companyapproval, logout, signinmodal } from '../store/reducers'
// import { logout } from '../redux/actions/auth'
// import { openLoginModal, rpfverify } from '../redux/actions/other'

function Dloader({ loader }) {
    // const { user } = decryptAndRetrieveData("isAuth", '123456789')
    const authData = decryptAndRetrieveData("isAuth", '123456789');
    const user = authData ? authData : null;

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { company_id } = useParams();
    console.log('id', company_id);

    const token = localStorage.getItem('accessToken')
    console.log('token', token);
    let usertype
    if (user && token) {
        const decodedToken = JSON.parse(atob(token.split('.')[1]))
        const user_type = decodedToken['custom:user_type']
        usertype = user_type
    }
    console.log('type', usertype);
    console.log('user', user);
    useEffect(() => {
        if (location.pathname.startsWith('/company/approve') || location.pathname.startsWith('/company/reject')) {
            if (user) {
                console.log('user12');

                if (usertype === 'admin') {
                    console.log('user34');
                    const action = location.pathname.startsWith('/company/approve') ? 'approve' : 'reject'
                    const params = {
                        company_id,
                        action
                    }
                    dispatch(companyapproval(params)).
                    then((response)=>{
                        localStorage.removeItem('path')
                        console.log('response',response.payload);
                        
                        toast.success(response.payload)

                    })
                    navigate('/dashboard')
                } else {
                    localStorage.setItem('path', location.pathname)
                    dispatch(logout());

                    toast.error(`Login using Administrator account to approve or reject the company.`)
                    dispatch(signinmodal())
                    navigate('/')

                }
            } else {
                console.log('user56');
                localStorage.setItem('path', location.pathname)
                toast.error(`Login using Administrator account to approve or reject the company.`)
                dispatch(signinmodal())
                navigate('/')
            }
        }
    }, [])
    return (
        <div style={{
            maxHeight: '83vh',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            {loader && (
                <>
                    <CircularProgress style={{ color: "#4A5E00" }} />
                    <h1>hiii</h1>
                </>

            )}
        </div>

    )
}

export default Dloader
